var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#star-line_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#222",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m13.188 3.04 2.178 5.19a.75.75 0 0 0 .625.457l5.575.482a.75.75 0 0 1 .425 1.319l-4.229 3.689a.76.76 0 0 0-.238.74l1.267 5.488a.75.75 0 0 1-1.114.814l-4.79-2.906a.74.74 0 0 0-.773 0l-4.79 2.907a.75.75 0 0 1-1.116-.815l1.268-5.488a.76.76 0 0 0-.238-.74l-4.23-3.69a.75.75 0 0 1 .426-1.318l5.575-.482a.75.75 0 0 0 .625-.458l2.178-5.19a.75.75 0 0 1 1.376 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "star-line_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5.33h24v24H.5z"
})))));
export default SvgStarLine;